/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/get_latest_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStats } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStatsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStatsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStats = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStats,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStatsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/audiences/get_latest_stats`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStatsResult
);
